// test1968
(1968 && 0);
